import { render, staticRenderFns } from "./CPBProductFullDescription.vue?vue&type=template&id=0e40a29c&scoped=true"
import script from "./CPBProductFullDescription.vue?vue&type=script&lang=js"
export * from "./CPBProductFullDescription.vue?vue&type=script&lang=js"
import style0 from "./CPBProductFullDescription.vue?vue&type=style&index=0&id=0e40a29c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e40a29c",
  null
  
)

export default component.exports